import PropTypes from "prop-types";

const ValidationMessages = ({ errorsArr }) => {
  for (let i = 0; i < errorsArr.length; i++) {
    if (errorsArr[i] === errorsArr[1]) {
      errorsArr.pop();
    }
  }
  const errorsList = errorsArr.map((err) => (
    <li key={err.msg} className="item item--modal_error_item">
      {`Oops! ${err.msg}`}
    </li>
  ));

  return <ul className="list list--modal_error_list">{errorsList}</ul>;
};

export default ValidationMessages;

ValidationMessages.propTypes = {
  errorsArr: PropTypes.array,
};
